export enum AudioFlowStep {
  ADD_AUDIO = 'add-audio',
  CLIP_AUDIO = 'clip-audio',
  CUSTOMIZE = 'customize',
  EXPORTING = 'exporting',
  SUBMITTING = 'submitting',
}
